import { render } from "./bolide_assistant_composer.html?vue&type=template&id=9c863b22&external"
import script from "./bolide_assistant_composer.js?vue&type=script&lang=js&external"
export * from "./bolide_assistant_composer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__